var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15.75 13" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M7.9 6.5a1.28 1.28 0 0 1-.4 1l-5 5a1.34 1.34 0 0 1-2 0 1.34 1.34 0 0 1 0-2l4-4-4-4a1.34 1.34 0 0 1 0-2 1.34 1.34 0 0 1 2 0l5 5a1.28 1.28 0 0 1 .4 1zm7.45-1l-5-5a1.34 1.34 0 0 0-2 0 1.34 1.34 0 0 0 0 2l4 4-4 4a1.34 1.34 0 0 0 0 2 1.34 1.34 0 0 0 2 0l5-5a1.28 1.28 0 0 0 .4-1 1.28 1.28 0 0 0-.4-1z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/CaretDoubleRight.svg